import { render, staticRenderFns } from "./Materiais.vue?vue&type=template&id=53fd1170&scoped=true&lang=pug&"
import script from "./Materiais.vue?vue&type=script&lang=js&"
export * from "./Materiais.vue?vue&type=script&lang=js&"
import style0 from "./Materiais.vue?vue&type=style&index=0&id=53fd1170&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fd1170",
  null
  
)

export default component.exports